import { render, staticRenderFns } from "./AiBuddyRequestRemaining.vue?vue&type=template&id=7dabae1a&scoped=true"
import script from "./AiBuddyRequestRemaining.vue?vue&type=script&lang=js"
export * from "./AiBuddyRequestRemaining.vue?vue&type=script&lang=js"
import style0 from "./AiBuddyRequestRemaining.vue?vue&type=style&index=0&id=7dabae1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dabae1a",
  null
  
)

export default component.exports